import PropTypes from "prop-types"
import TrayPicker from "./TrayPicker"

const TraySwatch = ({ onChange, ...props }) => {
  return <TrayPicker onClick={onChange} {...props} />
}

TraySwatch.propTypes = {
  onChange: PropTypes.func.isRequired,
  currentTray: PropTypes.string.isRequired,
  trays: PropTypes.arrayOf(PropTypes.string),
}

export default TraySwatch
